// eslint-disable-next-line import/prefer-default-export
export const GET_CORTE = 'GET_CORTE';
export const CHANGE_CORTE = 'CHANGE_CORTE';